import { makeStyles } from '@material-ui/styles';
import { royalblue } from '../../../../constants/Colors';

export default makeStyles(() => ({
    disabledLink: {
        color: royalblue,
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    linkButton: {
        padding: '5px 30px',
        width: '160px',
        fontSize: '15px',
    },
    container: {
        margin: '15px 0 15px 0',
        display: 'flex',
        '&:hover $icon': { visibility: 'visible' },
        '&:hover > $actions': {
            opacity: '1',
        },
    },
    actions: {
        opacity: '0',
        position: 'absolute',
        top: '5px',
        right: '7px',
    },
    icon: {
        cursor: 'pointer',
        visibility: 'hidden',
        marginLeft: '10px',
    },
}));
